namespace GeniuzPOS.PosShift {
    export class LogFuctionLvAppColumns {
        static columnsKey = 'PosShift.LogFuctionLvApp';
    }
}
